import { instance } from "../axios/axiosConfig";
import {
  CompanyBodyType,
  CreateCompanyFormDataType,
  EditCompanyBodyDataType,
  InviteUserPayload,
  UpdateRolePayload,
} from "../types/companyTypes.tsx";

const companyApi = {
  fetchCompanySettings() {
    return instance.get(`/api/company-settings/`);
  },
  fetchCompanyUsers() {
    return instance.get(`/api/company/invitations/`);
  },
  fetchCompaniesList() {
    return instance.get(`/api/clients/`, { params: { page_size: 100 } });
  },
  fetchCompanyById(id: string) {
    return instance.get(`/api/clients/${id}/`);
  },
  editCompanyById(body: EditCompanyBodyDataType) {
    return instance.patch(`/api/clients/${body.id}/`, { name: body.name });
  },
  inviteUser(payload: InviteUserPayload) {
    return instance.post(`/api/company/invitations/`, payload);
  },
  setCompanySettings(body: CompanyBodyType) {
    return instance.post(`/api/company-settings/`, body);
  },
  deleteInvitation(invitationId: number) {
    return instance.delete(`/api/company/invitations/${invitationId}/`);
  },
  updateProfileRole(profileId: number, payload: UpdateRolePayload) {
    return instance.patch(`/api/profiles/${profileId}/`, payload);
  },

  updateInvitationRole(invitationId: number, payload: UpdateRolePayload) {
    return instance.patch(`/api/company/invitations/${invitationId}/`, payload);
  },
  createCompany(body: CreateCompanyFormDataType) {
    return instance.post(`/api/admin-initial-creation/`, body);
  },
  resendInvitation(companyId: number, invitationId: number) {
    return instance.post(
      `/api/companies/${companyId}/invites/${invitationId}/resend/`,
    );
  },
};

export default companyApi;
